<template>
  <b-card title="Edit Category Accesories">
    <b-col cols="12">
      <b-row class="mb-2">
        <b-col cols="4">
          <b-button variant="primary" :to="{ name: 'accessories-category' }">
            Back to Category Accesories
          </b-button>
        </b-col>
      </b-row>
      <b-col cols="12" class="text-center mb-3">
        <b-img :src="dataForm.image || noImageURL" fluid rounded style="width: 150px; height: 150px; object-fit: cover;"></b-img>
        <b-form-file v-model="newImage" accept="image/*" @change="uploadImage" class="mt-2"></b-form-file>
      </b-col>
      <b-row>
        <b-col cols="12">
          <validation-observer ref="editAdmin">
            <b-form-group>
              <span>Name<span style="color:red">(*)</span></span>
              <validation-provider
                v-slot="{ errors }"
                name="Name"
                rules="required"
              >
                <b-form-input
                  v-model="dataForm.name"
                  type="text"
                  placeholder="Name"
                  :state="errors.length > 0 ? false : null"
                  style="margin-top:5px !important;"
                ></b-form-input>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group>
              <span>Description<span style="color:red">(*)</span></span>
              <validation-provider
                v-slot="{ errors }"
                name="Description"
                rules="required"
              >
                <b-form-input
                  v-model="dataForm.description"
                  type="text"
                  placeholder="Description""
                  :state="errors.length > 0 ? false : null"
                  style="margin-top:5px !important;"
                ></b-form-input>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

          </validation-observer>
        </b-col>
        <b-col cols="12">
          <b-button variant="success" @click="saveEdit"> Save </b-button
          >
        </b-col>
      </b-row>
    </b-col>
  </b-card>
</template>

<script>
import { mapActions } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";

export default {
  components: {
    "validation-observer": ValidationObserver,
    "validation-provider": ValidationProvider,
  },
  props: ["id"],
  data() {
    return {
      dataForm: {},
      newImage: null,
      noImageURL: require('@/assets/images/no-image.png'),
    };
  },
  methods: {
    saveEdit() {
      let forSave = this.dataForm;
      this.$refs.editAdmin.validate().then((result) => {
        if (result) {
          this.update({
            id: this.id,
            payload: forSave
          })
          .then(async (response) => {
            this.$bvToast.toast(
              `Successfully updated category`,
              {
                title: "Success",
                variant: "success",
                solid: true,
              }
            );
            this.$router.go(-1);
          })
          .catch((e) => {
            console.log({ e });
            this.$bvToast.toast(
              `Failed to update category`,
              {
                title: "Failed",
                variant: "danger",
                solid: true,
              }
            );
          });
        }
      });
    },
    uploadImage(event) {
      const file = event.target.files[0];
      const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
      const maxSize = 1 * 1024 * 1024;

      if (file) {
        if (!allowedTypes.includes(file.type)) {
          this.$bvToast.toast('Only PNG, JPG, and JPEG files are allowed.', {
            variant: 'danger',
            solid: true
          });
          return;
        }

        if (file.size > maxSize) {
          this.$bvToast.toast('Maximum file size is 1MB.', {
            variant: 'danger',
            solid: true
          });
          return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          this.dataForm.image = e.target.result; // Langsung tampilkan gambar
        };
        reader.readAsDataURL(file);
      }
    },
    ...mapActions({
      update: "category/updateCategoriesAccessories",
      get: "category/getCategoriesAccessoriesById"
    })
  },
  computed: {
  },
  async mounted() {
    this.get(this.id)
    .then((data) => {
      console.log(data.data);
      
      this.dataForm = data.data
    });
  },
  created() {
    document.title = "Edit Category Accessories | RSP";
  },
};
</script>